import {ReactElement} from 'react'
import CloseIcon from '@material-ui/icons/Close'
import {Trans} from 'react-i18next'

import {ModalHeader} from '../../../../../../App/PopupFactory/popups/components/shared/ModalHeader'
import {ModalBody} from '../../../../../../App/PopupFactory/popups/components/shared/ModalBody'
import messages from '../../../../../../../assets/messages'
import {SelectSupportReasonRow} from './SelectSupportReasonRow'
import {useStyles} from './styles'

type ChooseReasonModalContentProps = {
  onOtherRefundIssuesRedirect: () => void,
  onCantAccessDepositMethodIssueRedirect: () => void,
  onClose: () => void,
}

function ChooseReasonModalContent(props: ChooseReasonModalContentProps): ReactElement {
  const classes = useStyles()
  const {onClose, onOtherRefundIssuesRedirect, onCantAccessDepositMethodIssueRedirect} = props

  return (
    <>
      <ModalHeader>
        <CloseIcon className={classes.closeIcon} onClick={onClose} />
        <div className={classes.title}>
          <Trans {...messages.contactSupport} />
        </div>
        <div className={classes.subTitle}>
          <Trans {...messages.selectWithdrawalIssue} />
        </div>
      </ModalHeader>
      <ModalBody>
        <div className={classes.body}>
          <SelectSupportReasonRow
            title={<Trans {...messages.cantAccessOriginalDepositMethodTitle} />}
            subTitle={<Trans {...messages.cantAccessOriginalDepositMethodSubTitle} />}
            onClick={onCantAccessDepositMethodIssueRedirect}
          />
          <SelectSupportReasonRow
            title={<Trans {...messages.otherRefundIssuesTitle} />}
            subTitle={<Trans {...messages.cantAccessOriginalDepositMethodSubTitle} />}
            onClick={onOtherRefundIssuesRedirect}
          />
        </div>
      </ModalBody>
    </>
  )
}

export {ChooseReasonModalContent}
